<div class="acronym">
    <span class="letter">{{letter}}</span><span class="text">{{text}}</span>
</div>
<p class="description">{{description}}</p>
